import React, { Component } from 'react';
import {
    WithStyles,
    Card,
    CardContent,
    Typography,
    Grid,
    withStyles,
    Checkbox
} from "@material-ui/core";
import _ from 'lodash';
// import cx from 'classnames';
import { connect } from "react-redux";
import { styles } from './useStyles';
import { Tabs } from '../../components/tabs';
import DialogTopNav from "../../common/DialogTopNav";
import { StepStatus, StepProps } from "../../../common/types/Stepper";

import MyPATExpansionStep from "../../../common/MyPATExpansionStep";
import MyPATQuestionBar from "../../../common/MyPATQuestionBar";
import MyPATStepper from '../../../common/MyPATStepper';
import {
    createStyles, Button, DialogContent, IconButton, Dialog, DialogTitle
} from '@material-ui/core';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { bindActionCreators } from 'redux';
import { YourTask } from './CardDataTabs';
import contentRequestService from '../../services/contentRequestServices';
import { contentRequestStateAction } from '../../reducers/contentRequestStates';
import { handleDTopNavContent } from '../../helper/dtTopNavContent';
import {
    NavigateBeforeOutlined as BackIcon,
} from "@material-ui/icons";
import PerfectScrollbar from 'react-perfect-scrollbar';
import WithContent from "../../../mylibrary/containers/WithContent";
import { contentRequestAccordianActions } from '../../reducers/contentRequestAccordianState';
import { setSelectedQuestionsBySelectAll, setQuestionTabDetails, setResetQuestionsBySelectAll, selectAllCheckbox, setSelectAll } from '../../../mylibrary/reducers/bulkimportReducer';
import contentService from '../../../mylibrary/services/contentService';
import { showMsg } from '../../../header/actions/notificationAction';

enum FilterValues {
    status = 'status',
    published = 'PUBLISHED',
    contentType = 'contentType',
    question = 'question',
    MMCQ = 8
}

let selectedQuestionsCount = 0;
const preSelectedFilterContent: any = {
    contentMenu: "all",
    goalsDriller: {},
    contentFilterData: [{
        filterValue: FilterValues.contentType,
        isSelected: true,
        disabled: false,
        filters: [{
            filterValue: FilterValues.question,
            isSelected: true,
            disabled: false,
            filters: []
        }
        ]
    },
    {
        filterValue: FilterValues.status,
        isSelected: true,
        filters: [{
            filterValue: FilterValues.published,
            isSelected: true,
            filters: []
        }],
    }
    ]
}

interface SelectWithContentProps extends WithStyles<typeof styles> {
    classes: any,
    setQuestionTabDetails: any,
    activeTabState: number,
    params: any,
    setContentRequestState: Function,
    contentRequestStateData: any,
    selectQuestionDialogOpen: boolean,
    preSelectedFilterContent: any,
    handleChooseFromLibrary: Function,
    touchedQuestion: any,
    getQuestionIndexAndAccordianIndex: Function,
    setAccordingTouchIndex: Function,
    accordianTouched: any,
    bulkImportCount: number
    accordianCreateTouched: any,
    contentRequestId: string,
    contentRequestItemsId: any,
    checkAll: any,
    contentRequestQuestionId: string,
    questionTabDetails: any,
    setContentRequestItemsIdForFirstTime: Function,
    questionCode: string,
    setFilterQuestionArray: Function,
    filteredQuestionArray: any,
    selectAllData: any,
    accordianBulkIndex: number,
    selectAll: any,
    selectAllCheck: boolean,
    selectedQuestionsBySelectAll: any,
    setSelectedQuestionsBySelectAll: any,
    contentRequestItemsIdForFirstTime: string,
    passage: any,
    showMsg: any,
    setSelectAll: Function,
    setResetQuestionsBySelectAll: any,
    selectAllCheckbox: Function,
    isClickedOnImport: boolean,
    setIsClickedOnImport: Function
    isUnresolvedCount?: boolean
    handleChooseFromLibraryForUnresolvedContent: Function,
    unresolvedFeedbackCount: number,
}
interface SelectWithContentState {
    loader: boolean,
    selectedQuestionCount: number,
    selectedTempQuestions: any,
    selectedTrackedQuestionIds: any,
    selectQuestionDialogData: {
        sectionId: string;
        subSectionId: string;
        quesCodeAllowed: number;
        noOfQuestions: number;
        replaceIndex: number;
        replaceIndexJ: number;
        content_Id: string;
        addedQuestions: any;
    },
    chooseLibraryKey: any,
    data: any,
    selectQuestionDialogOpen: boolean,
    selectVideoDialogOpen: boolean,
    filterSelectedQuestion: any,
    preSelectedFilterContent: any,
}

class SelectWithContent extends Component<
    SelectWithContentProps,
    SelectWithContentState
    > {
    constructor(props: SelectWithContentProps) {
        super(props);
        this.state = {
            loader: true,
            selectedQuestionCount: 0,
            selectedTempQuestions: [],
            selectedTrackedQuestionIds: {},
            selectQuestionDialogData: {
                sectionId: "",
                subSectionId: "",
                quesCodeAllowed: -1,
                noOfQuestions: 0,
                replaceIndex: -1,
                replaceIndexJ: -1,
                content_Id: "",
                addedQuestions: []
            },
            chooseLibraryKey: '',
            data: [],
            selectQuestionDialogOpen: this.props.selectQuestionDialogOpen,
            selectVideoDialogOpen: false,
            filterSelectedQuestion: [...this.props.filteredQuestionArray],
            preSelectedFilterContent: { ...this.props.preSelectedFilterContent },
        };

    }


    handleContentSelect = (Count: any) => {
        const firstSelectedQuestion = Count[0];
        //fordebugPurpose
        if (!this.props.isClickedOnImport && this.props.questionTabDetails.length && Count.length >= 1) {
            this.setState({
                selectedTempQuestions: Count
            }, () => { selectedQuestionsCount = this.state.selectedTempQuestions.length })
        }
        else {
            if (Count.length > 0) {
                this.setState({
                    selectedQuestionCount: Count.length,
                });
            } else {
                this.setState({
                    selectedQuestionCount: 0,
                });

            }
            this.setState({ selectedTempQuestions: firstSelectedQuestion });
        }
    }

    handleBulkContentSelect = (Count: any) => {
        if (Count.length > 0) {
            this.setState({
                selectedQuestionCount: Count.length,
            });
        } else {
            this.setState({
                selectedQuestionCount: 0,
            });

        }
        this.setState({ selectedTempQuestions: Count });
    }

    handleBulkImport = (questionTabDetails: any) => {
        let { selectedTempQuestions, chooseLibraryKey, data } = this.state;
        let newUpdatedAccordianTouchedArray: any = [];
        let bulkImportData = {
            contents: []
        };
        const { questionCode = '' } = this.props;
        let contents: any = [];
        let selectedQuestions: any = [...selectedTempQuestions];
        let getCheckBoxValue: any = [...this.props.checkAll];
        let getSelectValue: any = {};
        let bulkAccordianIndex = 0;
        let newQuestionTabIndex = [...this.props.questionTabDetails];
        questionTabDetails.map((bulkData: any, qIndex: number) => {
            let questionIndex = bulkData.questionIndex;
            let accordianIndex = bulkData.accordianIndex
            const { getQuestionIndexAndAccordianIndex, accordianTouched, accordianCreateTouched } = this.props;
            const getQuestionAndAccordianIndex = accordianCreateTouched;
            accordianTouched.map((acc: any, index: number) => {
                if (acc.accordianIndex === accordianIndex) {
                    let questionContent: any = [];
                    let newUpdatedAttachedQuestion = {};
                    bulkAccordianIndex = accordianIndex;
                    if (!newUpdatedAccordianTouchedArray.length)
                        questionContent = acc.questionContent;
                    else
                        questionContent = newUpdatedAccordianTouchedArray[index].questionContent

                    const findQuestionIndex = questionContent.findIndex((element: any) => element.questionIndex === questionIndex);
                    if (index !== -1) {
                        if (questionCode === '5') {
                            const { count, code, type } = this.props.passage[questionIndex - 1];
                            if(selectedTempQuestions[qIndex].passageData[0].hasOwnProperty('questionCode') && selectedTempQuestions[qIndex].passageData[0].hasOwnProperty('questionType')){
                                if (count === selectedTempQuestions[qIndex].passageData.length &&
                                    Number(code) === selectedTempQuestions[qIndex].passageData[0].questionCode &&
                                    type === selectedTempQuestions[qIndex].passageData[0].questionType
                                    ) {
                                    newUpdatedAttachedQuestion = {
                                        contentId: selectedTempQuestions[qIndex].contentId,
                                        content_Id: selectedTempQuestions[qIndex].content_Id,
                                        isJobCompleted: false,
                                        isTouched: true,
                                        unresolvedFeedbackCount: this.props.unresolvedFeedbackCount,
                                    };
                                    const contentData = {
                                        sequenceNo: questionIndex,
                                        contentId: selectedTempQuestions[qIndex].content_Id
                                    }
                                    contents.push(contentData);
                                    getCheckBoxValue[accordianIndex] = {
                                        ...getCheckBoxValue[accordianIndex],
                                        ['questionCheck']: {
                                            ...getCheckBoxValue[accordianIndex]['questionCheck'],
                                            [`ACC${accordianIndex}${questionIndex}`]: false
                                        },
                                        [`disabledCheck`]: {
                                            ...getCheckBoxValue[accordianIndex]['disabledCheck'],
                                            [`ACCDISABLE${accordianIndex}${questionIndex}`]: true
                                        }
                                    }
                                    getSelectValue = { ...this.props.selectAll };
                                    getSelectValue = { ...getSelectValue, [`ACC${accordianIndex}`]: false };
                                } else {
                                    this.props.showMsg('DB count doest match from the selected question or code does not match', 'error');
                                    selectedQuestions = selectedQuestions.filter((ele: any) => ele.contentId !== selectedTempQuestions[qIndex].contentId);
                                    getCheckBoxValue[accordianIndex] = {
                                        ...getCheckBoxValue[accordianIndex],
                                        ['questionCheck']: {
                                            ...getCheckBoxValue[accordianIndex]['questionCheck'],
                                            [`ACC${accordianIndex}${questionIndex}`]: false
                                        },
                                        // [`disabledCheck`]: {
                                        //     ...getCheckBoxValue[accordianIndex]['disabledCheck'],
                                        //     [`ACCDISABLE${accordianIndex}${questionIndex}`]: true
                                        // }
                                    }
                                    getSelectValue = { ...this.props.selectAll };
                                    getSelectValue = { ...getSelectValue, [`ACC${accordianIndex}`]: false };
                                }
                            }else{
                                if (count === selectedTempQuestions[qIndex].passageData.length) {
                                    newUpdatedAttachedQuestion = {
                                        contentId: selectedTempQuestions[qIndex].contentId,
                                        content_Id: selectedTempQuestions[qIndex].content_Id,
                                        isJobCompleted: false,
                                        isTouched: true,
                                        unresolvedFeedbackCount: this.props.unresolvedFeedbackCount,
                                    };
                                    const contentData = {
                                        sequenceNo: questionIndex,
                                        contentId: selectedTempQuestions[qIndex].content_Id
                                    }
                                    contents.push(contentData);
                                    getCheckBoxValue[accordianIndex] = {
                                        ...getCheckBoxValue[accordianIndex],
                                        ['questionCheck']: {
                                            ...getCheckBoxValue[accordianIndex]['questionCheck'],
                                            [`ACC${accordianIndex}${questionIndex}`]: false
                                        },
                                        [`disabledCheck`]: {
                                            ...getCheckBoxValue[accordianIndex]['disabledCheck'],
                                            [`ACCDISABLE${accordianIndex}${questionIndex}`]: true
                                        }
                                    }
                                    getSelectValue = { ...this.props.selectAll };
                                    getSelectValue = { ...getSelectValue, [`ACC${accordianIndex}`]: false };
                                } else {
                                    this.props.showMsg('DB count doest match from the selected question', 'error');
                                    selectedQuestions = selectedQuestions.filter((ele: any) => ele.contentId !== selectedTempQuestions[qIndex].contentId);
                                    getCheckBoxValue[accordianIndex] = {
                                        ...getCheckBoxValue[accordianIndex],
                                        ['questionCheck']: {
                                            ...getCheckBoxValue[accordianIndex]['questionCheck'],
                                            [`ACC${accordianIndex}${questionIndex}`]: false
                                        },
                                        // [`disabledCheck`]: {
                                        //     ...getCheckBoxValue[accordianIndex]['disabledCheck'],
                                        //     [`ACCDISABLE${accordianIndex}${questionIndex}`]: true
                                        // }
                                    }
                                    getSelectValue = { ...this.props.selectAll };
                                    getSelectValue = { ...getSelectValue, [`ACC${accordianIndex}`]: false };
                                }

                            }

                        } else {
                            newUpdatedAttachedQuestion = {
                                content_Id: selectedTempQuestions[qIndex]._id.substring(0, 24),
                                contentId: selectedTempQuestions[qIndex].contentId,
                                isJobCompleted: false,
                                isTouched: true,
                                unresolvedFeedbackCount: this.props.unresolvedFeedbackCount,
                            }
                            const contentData = {
                                sequenceNo: questionIndex,
                                contentId: selectedTempQuestions[qIndex]._id.substring(0, 24)
                            }
                            contents.push(contentData);
                            getCheckBoxValue[accordianIndex] = {
                                ...getCheckBoxValue[accordianIndex],
                                ['questionCheck']: {
                                    ...getCheckBoxValue[accordianIndex]['questionCheck'],
                                    [`ACC${accordianIndex}${questionIndex}`]: false
                                },
                                [`disabledCheck`]: {
                                    ...getCheckBoxValue[accordianIndex]['disabledCheck'],
                                    [`ACCDISABLE${accordianIndex}${questionIndex}`]: true
                                }
                            }
                            getSelectValue = { ...this.props.selectAll };
                            getSelectValue = { ...getSelectValue, [`ACC${accordianIndex}`]: false };
                        }
                        const newUpdatedAccordianTouchedObject = { ...newUpdatedAttachedQuestion };
                        let updatedQuestionContentArray = [...questionContent];
                        updatedQuestionContentArray[findQuestionIndex] = { ...updatedQuestionContentArray[findQuestionIndex], attachedQuestions: { ...newUpdatedAccordianTouchedObject, previousVersion: { ...updatedQuestionContentArray[findQuestionIndex]['attachedQuestions'].previousVersion } } }
                        newUpdatedAccordianTouchedArray = [...accordianTouched];
                        newUpdatedAccordianTouchedArray[index] = {
                            ...newUpdatedAccordianTouchedArray[index],
                            questionContent: [
                                ...updatedQuestionContentArray,
                            ]
                        }
                        // getCheckBoxValue[accordianIndex] = {
                        // ...getCheckBoxValue[accordianIndex],
                        // ['questionCheck']: {
                        // ...getCheckBoxValue[accordianIndex]['questionCheck'],
                        // [`ACC${accordianIndex}${questionIndex}`]: false
                        // },
                        // [`disabledCheck`]: {
                        // ...getCheckBoxValue[accordianIndex]['disabledCheck'],
                        // [`ACCDISABLE${accordianIndex}${questionIndex}`]: true
                        // }
                        // }
                        // getSelectValue = { ...this.props.selectAll };
                        // getSelectValue = { ...getSelectValue, [`ACC${accordianIndex}`]: false };
                        const filterData = newQuestionTabIndex.filter((ele) => ele.accordianIndex === accordianIndex && ele.questionIndex !== questionIndex);
                        newQuestionTabIndex = [...filterData];
                    }
                }
            })
        })
        const { setAccordingTouchIndex } = this.props;
        bulkImportData.contents = contents;
        this.props.selectAllCheckbox({
            item: [...getCheckBoxValue]
        });
        this.props.setSelectAll({
            item: { ...getSelectValue }
        });
        this.props.setQuestionTabDetails({
            item: [...newQuestionTabIndex]
        })
        if (!this.props.unresolvedFeedbackCount) {
            if (questionCode === '5') {
                this.addBulkImportQuestionForParagraph(bulkImportData, bulkAccordianIndex);
            } else {
                this.addBulkImportQuestion(bulkImportData, bulkAccordianIndex);
            }
        }
        setAccordingTouchIndex(newUpdatedAccordianTouchedArray);
        this.handleFilterSelectedQuestion(selectedQuestions);
        this.props.handleChooseFromLibrary()
    }

    handleContentSelectAll = (Count: any) => {
        this.handleTrackSelectedQuestionIds(Count)
        this.setState({ selectedTempQuestions: Count, selectedQuestionCount: Count.length });
    }

    handleTrackSelectedQuestionIds(Count: any) {
        const { selectedTrackedQuestionIds, selectQuestionDialogData } = this.state;
        const { quesCodeAllowed, subSectionId } = selectQuestionDialogData
        Count.forEach((question: any) => {
            const key = question.content_Id
            if (!selectedTrackedQuestionIds.hasOwnProperty(key)) {
                selectedTrackedQuestionIds[key] = {
                    quesCodeAllowed,
                    subSectionId,
                    content_Id: question.content_Id
                }
            }
        });
        this.setState({ selectedTrackedQuestionIds });
    }

    handleCheckContentExist = (content_Id: string) => {
        const { selectedTrackedQuestionIds, selectQuestionDialogData } = this.state
        const { subSectionId: selectedSubSectionId, content_Id: selectedContentId, addedQuestions, quesCodeAllowed: selectedQuestCode, replaceIndex } = selectQuestionDialogData
        const addedContent_Ids: any = new Set(addedQuestions.map((content: any) => content.content_Id))
        addedContent_Ids.delete(selectedContentId)
        const key = content_Id
        let isContentExist = false;
        if (selectedTrackedQuestionIds.hasOwnProperty(key)) {
            const quesCodeAllowed = selectedTrackedQuestionIds[key].quesCodeAllowed
            const subSectionId = selectedTrackedQuestionIds[key].subSectionId
            if (replaceIndex !== -1) {
                if (content_Id !== selectedContentId && addedContent_Ids.has(content_Id)) {
                    isContentExist = true
                }
            } else {
                if (selectedQuestCode == quesCodeAllowed) {
                    if (selectedSubSectionId !== subSectionId) {
                        isContentExist = true
                    }
                }
            }

        }
        return isContentExist
    }

    addBulkImportQuestionForParagraph = (bulkImportData: any, accordianIndex: any) => {
        const { contentRequestId = '', contentRequestItemsId, contentRequestQuestionId, setContentRequestItemsIdForFirstTime, accordianTouched } = this.props;
        let contents: any;
        contents = [];

        if (!contentRequestItemsId && !accordianTouched[accordianIndex]['questionContent'].filter((ele: any) => ele.attachedQuestions.isTouched).length) {
            const { contents } = bulkImportData;
            let contentForPost: any = [];
            contents.forEach((content: any) => {
                contentForPost.push({
                    sequenceNo: content.sequenceNo,
                    content_id: content.contentId
                })
            })
            const reqBody = {
                contents: [
                    ...contentForPost
                ],

                type: 'question',
                contentRequestQuestionId,
                contentRequestId
            }
            contentRequestService.createQuestionForPostContentRequest({ ...reqBody }).then((response: any) => {
                const { contentRequestItem: { _id = '' } = {} } = response;
                setContentRequestItemsIdForFirstTime({ id: _id });
            });
        }
        else {
            const { contents = [] } = bulkImportData;
            contents.forEach((element: any) => {
                if (contentRequestItemsId) {
                    const { _id = '' } = contentRequestItemsId;
                    const reqBody =
                    {
                        "contentId": element.contentId,
                        "sequenceNo": element.sequenceNo
                    };
                    contentRequestService.createQuestionForPutContentRequestForParagraph(_id, { ...reqBody }).then((response: any) => {
                    });
                } else {
                    const reqBody = {
                        "contentId": element.contentId,
                        "sequenceNo": element.sequenceNo
                    };
                    contentRequestService.createQuestionForPutContentRequestForParagraph(this.props.contentRequestItemsIdForFirstTime, { ...reqBody }).then((response: any) => {
                    });
                }
            });
        }
    }

    addBulkImportQuestion = (bulkImportData: any, accordianIndex: any) => {
        const { contentRequestId = '', contentRequestItemsId, contentRequestQuestionId, setContentRequestItemsIdForFirstTime, accordianTouched } = this.props;
        let contents: any;
        contents = [];

        if (!contentRequestItemsId && !accordianTouched[accordianIndex]['questionContent'].filter((ele: any) => ele.attachedQuestions.isTouched).length) {
            const { contents } = bulkImportData;
            let contentForPost: any = [];
            contents.forEach((content: any) => {
                contentForPost.push({
                    sequenceNo: content.sequenceNo,
                    content_id: content.contentId
                })
            })
            const reqBody = {
                contents: [
                    ...contentForPost
                ],

                type: 'question',
                contentRequestQuestionId,
                contentRequestId
            }
            contentRequestService.createQuestionForPostContentRequest({ ...reqBody }).then((response: any) => {
                const { contentRequestItem: { _id = '' } = {} } = response;
                setContentRequestItemsIdForFirstTime({ id: _id });
            });
        }
        else {
            if (contentRequestItemsId) {
                const { _id = '' } = contentRequestItemsId;
                const reqBody = { ...bulkImportData };
                contentRequestService.createQuestionForPutContentRequest(_id, { ...reqBody }).then((response: any) => {
                });
            } else {
                const reqBody = { ...bulkImportData };
                contentRequestService.createQuestionForPutContentRequest(this.props.contentRequestItemsIdForFirstTime, { ...reqBody }).then((response: any) => {
                });
            }
        }
    }

    addParagraphQuestion = (content_Id: string, index: number, accordianIndex: number) => {
        const { contentRequestId = '', contentRequestItemsId, contentRequestQuestionId, setContentRequestItemsIdForFirstTime, accordianTouched } = this.props;
        if (!contentRequestItemsId && !accordianTouched[accordianIndex]['questionContent'].filter((ele: any) => ele.attachedQuestions.isTouched).length) {
            const reqBody = {
                contents: [
                    {
                        sequenceNo: index,
                        content_id: content_Id.substring(0, 24)
                    }
                ],
                type: 'question',
                contentRequestQuestionId,
                contentRequestId
            }
            contentRequestService.createQuestionForPostContentRequest({ ...reqBody }).then((response: any) => {
                const { contentRequestItem: { _id = '' } = {} } = response;
                setContentRequestItemsIdForFirstTime({ id: _id });
            });
        } else {
            if (contentRequestItemsId) {
                const { _id = '' } = contentRequestItemsId;
                const reqBody = {
                    sequenceNo: index,
                    contentId: content_Id.substring(0, 24)
                };
                contentRequestService.createQuestionForPutContentRequestForParagraph(_id, { ...reqBody }).then((response: any) => {
                });
            } else {
                const reqBody = {
                    sequenceNo: index,
                    contentId: content_Id.substring(0, 24)
                };
                contentRequestService.createQuestionForPutContentRequestForParagraph(this.props.contentRequestItemsIdForFirstTime, { ...reqBody }).then((response: any) => {
                });

            }
        }
    }
    addQuestionInImport = (content_Id: string, index: number, accordianIndex: number) => {
        const { contentRequestId = '', contentRequestItemsId, contentRequestQuestionId, setContentRequestItemsIdForFirstTime, accordianTouched } = this.props;
        if (!contentRequestItemsId && !accordianTouched[accordianIndex]['questionContent'].filter((ele: any) => ele.attachedQuestions.isTouched).length) {
            const reqBody = {
                contents: [
                    {
                        sequenceNo: index,
                        content_id: content_Id.substring(0, 24)
                    }
                ],
                type: 'question',
                contentRequestQuestionId,
                contentRequestId
            }
            contentRequestService.createQuestionForPostContentRequest({ ...reqBody }).then((response: any) => {
                const { contentRequestItem: { _id = '' } = {} } = response;
                setContentRequestItemsIdForFirstTime({ id: _id });
            });         

        } else {
            if (contentRequestItemsId) {
                const { _id = '' } = contentRequestItemsId;
                const reqBody = {
                    contents: [{
                        sequenceNo: index,
                        contentId: content_Id.substring(0, 24)
                    }]
                };
                contentRequestService.createQuestionForPutContentRequest(_id, { ...reqBody }).then((response: any) => {
                });
            } else {
                const reqBody = {
                    contents: [{
                        sequenceNo: index,
                        contentId: content_Id.substring(0, 24)
                    }]
                };
                contentRequestService.createQuestionForPutContentRequest(this.props.contentRequestItemsIdForFirstTime, { ...reqBody }).then((response: any) => {
                });

            }
        }
    }

    handleAddContentClick = () => {
        let { selectedTempQuestions, chooseLibraryKey, data } = this.state;
        const { accordianTouched, accordianCreateTouched } = this.props;
        // for debug purpose
        if (!this.props.isClickedOnImport) { if (!this.props.questionTabDetails.length) { this.handleBulkImport(this.props.selectedQuestionsBySelectAll) } else this.handleBulkImport(this.props.questionTabDetails) }
        else {
            const getQuestionAndAccordianIndex = accordianCreateTouched;
            const { accordianIndex = 0, questionIndex = 1 } = getQuestionAndAccordianIndex;
            let newUpdatedAccordianTouchedArray: any = [];
            const { questionCode = '' } = this.props;
            let passageData: any = [];
            let getCheckBoxValue: any = [];
            let getSelectValue: any = {};
            let isQuestionBeAdded = true;
            accordianTouched.map((acc: any, index: number) => {
                if (acc.accordianIndex === accordianIndex) {
                    const { questionContent = [] } = acc;
                    const findQuestionIndex = questionContent.findIndex((element: any) => element.questionIndex === questionIndex);
                    if (index !== -1) {
                        let newUpdatedAttachedQuestion = {};
                        if (questionCode === '5') {
                            const { count, code,type } = this.props.passage[questionIndex - 1];
                            if(selectedTempQuestions.passageData[0].hasOwnProperty('questionCode') && selectedTempQuestions.passageData[0].hasOwnProperty('questionType')){
                                if (count === selectedTempQuestions.passageData.length && 
                                    Number(code) === selectedTempQuestions.passageData[0].questionCode &&
                                    type === selectedTempQuestions.passageData[0].questionType
                                ) {
                                    newUpdatedAttachedQuestion = {
                                        contentId: selectedTempQuestions.contentId,
                                        content_Id: selectedTempQuestions.content_Id,
                                        isJobCompleted: false,
                                        isTouched: true,
                                        unresolvedFeedbackCount: this.props.unresolvedFeedbackCount
                                    }
                                    getCheckBoxValue = [...this.props.checkAll];
                                    getCheckBoxValue[accordianIndex] = {
                                        ...getCheckBoxValue[accordianIndex],
                                        ['questionCheck']: {
                                            ...getCheckBoxValue[accordianIndex]['questionCheck'],
                                            [`ACC${accordianIndex}${questionIndex}`]: false
                                        },
                                        [`disabledCheck`]: {
                                            ...getCheckBoxValue[accordianIndex]['disabledCheck'],
                                            [`ACCDISABLE${accordianIndex}${questionIndex}`]: true
                                        }
                                    }
                                    getSelectValue = { ...this.props.selectAll };
                                    getSelectValue = { ...getSelectValue, [`ACC${accordianIndex}`]: false };
                                } else {
                                    isQuestionBeAdded = false;
                                    getCheckBoxValue = [...this.props.checkAll];
                                    getCheckBoxValue[accordianIndex] = {
                                        ...getCheckBoxValue[accordianIndex],
                                        ['questionCheck']: {
                                            ...getCheckBoxValue[accordianIndex]['questionCheck'],
                                            [`ACC${accordianIndex}${questionIndex}`]: false
                                        },
                                        // [`disabledCheck`]: {
                                        //     ...getCheckBoxValue[accordianIndex]['disabledCheck'],
                                        //     [`ACCDISABLE${accordianIndex}${questionIndex}`]: true
                                        // }
                                    }
                                    getSelectValue = { ...this.props.selectAll };
                                    getSelectValue = { ...getSelectValue, [`ACC${accordianIndex}`]: false };
                                    this.props.showMsg('Cannot add Question as count doesnt match from db or code does not match', 'error');
                                }
                            }else{

                                if (count === selectedTempQuestions.passageData.length ) {
                                    newUpdatedAttachedQuestion = {
                                        contentId: selectedTempQuestions.contentId,
                                        content_Id: selectedTempQuestions.content_Id,
                                        isJobCompleted: false,
                                        isTouched: true,
                                        unresolvedFeedbackCount: this.props.unresolvedFeedbackCount
                                    }
                                    getCheckBoxValue = [...this.props.checkAll];
                                    getCheckBoxValue[accordianIndex] = {
                                        ...getCheckBoxValue[accordianIndex],
                                        ['questionCheck']: {
                                            ...getCheckBoxValue[accordianIndex]['questionCheck'],
                                            [`ACC${accordianIndex}${questionIndex}`]: false
                                        },
                                        [`disabledCheck`]: {
                                            ...getCheckBoxValue[accordianIndex]['disabledCheck'],
                                            [`ACCDISABLE${accordianIndex}${questionIndex}`]: true
                                        }
                                    }
                                    getSelectValue = { ...this.props.selectAll };
                                    getSelectValue = { ...getSelectValue, [`ACC${accordianIndex}`]: false };
                                } else {
                                    isQuestionBeAdded = false;
                                    getCheckBoxValue = [...this.props.checkAll];
                                    getCheckBoxValue[accordianIndex] = {
                                        ...getCheckBoxValue[accordianIndex],
                                        ['questionCheck']: {
                                            ...getCheckBoxValue[accordianIndex]['questionCheck'],
                                            [`ACC${accordianIndex}${questionIndex}`]: false
                                        },
                                        // [`disabledCheck`]: {
                                        //     ...getCheckBoxValue[accordianIndex]['disabledCheck'],
                                        //     [`ACCDISABLE${accordianIndex}${questionIndex}`]: true
                                        // }
                                    }
                                    getSelectValue = { ...this.props.selectAll };
                                    getSelectValue = { ...getSelectValue, [`ACC${accordianIndex}`]: false };
                                    this.props.showMsg('Cannot add Question as count doesnt match from db', 'error');
                                }
                            }
                        } else {
                            newUpdatedAttachedQuestion = {
                                content_Id: selectedTempQuestions._id,
                                contentId: selectedTempQuestions.contentId,
                                isJobCompleted: false,
                                isTouched: true,
                                unresolvedFeedbackCount: this.props.unresolvedFeedbackCount,
                            }
                            getCheckBoxValue = [...this.props.checkAll];
                            getCheckBoxValue[accordianIndex] = {
                                ...getCheckBoxValue[accordianIndex],
                                ['questionCheck']: {
                                    ...getCheckBoxValue[accordianIndex]['questionCheck'],
                                    [`ACC${accordianIndex}${questionIndex}`]: false
                                },
                                [`disabledCheck`]: {
                                    ...getCheckBoxValue[accordianIndex]['disabledCheck'],
                                    [`ACCDISABLE${accordianIndex}${questionIndex}`]: true
                                }
                            }
                            getSelectValue = { ...this.props.selectAll };
                            getSelectValue = { ...getSelectValue, [`ACC${accordianIndex}`]: false };


                        }
                        if (!this.props.isUnresolvedCount) {
                            if (questionCode !== '5') {
                                this.addQuestionInImport(selectedTempQuestions._id, questionIndex, accordianIndex);
                            } else {
                                let contents: any = [];
                                selectedTempQuestions.passageData.map((ele: any) => {
                                    contents.push({
                                        contentId: ele.id,
                                        sequenceNo: questionIndex
                                    })
                                })
                                isQuestionBeAdded && this.addParagraphQuestion(selectedTempQuestions.content_Id, questionIndex, accordianIndex);
                                // this.addBulkImportQuestion({ contents })
                            }
                        }
                        const newUpdatedAccordianTouchedObject = { ...newUpdatedAttachedQuestion };
                        let updatedQuestionContentArray = [...questionContent];
                        updatedQuestionContentArray[findQuestionIndex] = { ...updatedQuestionContentArray[findQuestionIndex], attachedQuestions: { ...newUpdatedAccordianTouchedObject, previousVersion: { ...updatedQuestionContentArray[findQuestionIndex]['attachedQuestions'].previousVersion } } }
                        newUpdatedAccordianTouchedArray = [...accordianTouched];
                        newUpdatedAccordianTouchedArray[index] = {
                            ...newUpdatedAccordianTouchedArray[index],
                            questionContent: [
                                ...updatedQuestionContentArray,
                            ]
                        }
                    }
                }
            })
            const { setAccordingTouchIndex } = this.props;
            setAccordingTouchIndex(newUpdatedAccordianTouchedArray);
            this.props.selectAllCheckbox({
                item: [...getCheckBoxValue]
            });
            this.props.setSelectAll({
                item: { ...getSelectValue }
            });
            isQuestionBeAdded && this.handleFilterSelectedQuestion(selectedTempQuestions)
            this.props.setIsClickedOnImport({
                booleanValue: false
            })
            if (!this.props.isUnresolvedCount) {
                this.props.handleChooseFromLibrary();
            } else {
                this.props.handleChooseFromLibraryForUnresolvedContent()
            }

        }
    };

    questionsToImport(count: any) {
        if (count)
            return count
        else
            1
    }

    handleQuestoinSelect = () => {
        if (this.props.isClickedOnImport) {
            return this.handleContentSelect.bind(this)
        }
        else if (this.props.questionTabDetails.length)
            return this.handleBulkContentSelect.bind(this)
        else if (this.props.selectedQuestionsBySelectAll.length) {
            return this.handleBulkContentSelect.bind(this)
        }
        else
            return this.handleContentSelect.bind(this)
    }

    handleImportCount = (bulkcount: any) => {
        if (bulkcount && bulkcount.length)
            return bulkcount.length
        else
            return 1

    }
    handleSelectedFilterQuestions = (setFilterQuestions: any) => {
        const { setFilterQuestionArray } = this.props;
        setFilterQuestionArray(setFilterQuestions);

    }

    handleFilterSelectedQuestion = (selectedTempQuestions: any) => {
        if (Array.isArray(selectedTempQuestions)) {
            this.setState({
                filterSelectedQuestion: [...this.props.filteredQuestionArray, ...selectedTempQuestions],
            }, () => {
                const { filterSelectedQuestion } = this.state;
                this.handleSelectedFilterQuestions(filterSelectedQuestion)
            })

        } else {
            this.setState({
                filterSelectedQuestion: [...this.props.filteredQuestionArray, { ...selectedTempQuestions }],
            }, () => {
                const { filterSelectedQuestion } = this.state;
                this.handleSelectedFilterQuestions(filterSelectedQuestion)
            })
        }
    }

    handleTotalQuestionsToImport = (CountBySelectAll: any, manuallyCount: any) => {
        if (this.props.isClickedOnImport) {
            return 1
        }
        else if (CountBySelectAll.length)
            return CountBySelectAll.length
        else if (manuallyCount.length)
            return manuallyCount.length
        else
            return 1
    }
    handleResetAllCount = () => {
        // this.props.setQuestionTabDetails({
        // item: []
        // })
        // this.props.setSelectedQuestionsBySelectAll({
        // item: []
        // })
        this.props.setResetQuestionsBySelectAll({
            item: 0
        })
        this.setState({
            selectedQuestionCount: 0
        })
        this.props.setIsClickedOnImport({
            booleanValue: false
        })
    }
    hanldeResetAfterAddingContent = () => {
        this.props.setQuestionTabDetails({
            item: []
        })
        this.props.setSelectedQuestionsBySelectAll({
            item: []
        })
        this.props.setResetQuestionsBySelectAll({
            item: 0
        })
        this.setState({
            selectedQuestionCount: 0
        })
        this.props.setIsClickedOnImport({
            booleanValue: false
        })
    }

    render = () => {
        const {
            selectedQuestionCount
        } = this.state;
        let { selectQuestionDialogOpen, bulkImportCount } = this.props;
        const { classes } = this.props;
        const otherDialogProps = {
            fullScreen: true,
        };
        let { selectedTempQuestions, filterSelectedQuestion, selectedTrackedQuestionIds, preSelectedFilterContent } = this.state;
        return (
            <Dialog
                {...otherDialogProps}
                open={selectQuestionDialogOpen}>

                <div style={{ width: 'auto' }}>
                    <DialogTitle classes={{ root: classes.dialogTitle }}>
                        <>
                            <Grid container justify="space-between" alignItems="center">
                                <Grid item xs="auto">
                                    <Typography
                                        color="textPrimary"
                                        variant="body1"
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => {
                                            this.props.handleChooseFromLibrary()
                                            this.handleResetAllCount()

                                        }}

                                    >
                                        <BackIcon classes={{ root: classes.backIconRoot }}
                                        />
                                        <strong>Back </strong>
                                    </Typography>
                                </Grid>
                                <Grid item xs />
                                <Grid item xs="auto">
                                    <Typography variant="caption" inline>
                                        <b style={{ marginRight: '20px', fontSize: 16, }}>{selectedQuestionCount}/ {this.handleTotalQuestionsToImport(this.props.selectedQuestionsBySelectAll, this.props.questionTabDetails)}</b>
                                    </Typography>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        disabled={selectedQuestionCount < this.handleTotalQuestionsToImport(this.props.selectedQuestionsBySelectAll, this.props.questionTabDetails) || selectedQuestionCount > this.handleTotalQuestionsToImport(this.props.selectedQuestionsBySelectAll, this.props.questionTabDetails)}
                                        onClick={() => {
                                            this.handleAddContentClick();
                                            this.hanldeResetAfterAddingContent();
                                        }}
                                    >
                                        Add Content
 </Button>
                                </Grid>
                            </Grid>
                        </>
                    </DialogTitle>
                    <DialogContent classes={{ root: classes.dialogContent }}>
                        {/* <PerfectScrollbar className={`dialog-content ${classes.perfectScrollbar}`}> */}
                        <WithContent
                            isInPopUp={true}
                            selectedQuestionsCount={selectedQuestionsCount}
                            Count={selectedTempQuestions}
                            selectedTrackedQuestionIds={selectedTrackedQuestionIds}
                            filterSelectedQuestion={this.props.filteredQuestionArray.filter((ele: any) => Number(ele.contentSubTypeCode) === Number(this.props.questionCode))}
                            onContentSelect={this.handleQuestoinSelect()}
                            onContentSelectAll={this.handleContentSelectAll.bind(this)}
                            onCheckContentExist={this.handleCheckContentExist.bind(this)}
                            selectedFilterContent={this.props.preSelectedFilterContent}
                            fromTestPaper={true}
                            type="question"
                            removeDisabilityFromCheckBox={true}
                            isSelectAllRequired={false}
                            contentCreateOption={false}
                            isCreatedByMe={true}
                        />
                        {/* </PerfectScrollbar> */}
                    </DialogContent>
                </div>
            </Dialog>
        )
    }
}

const mapStateToProps = (state: any) => ({
    activeTabState: _.get(state, 'contentRequestData.tabData.activeTab'),
    contentRequestStateData: _.get(state, 'contentRequestData.contentRequestData', {}),
    accordianTouched: _.get(state, 'contentRequestData.contentRequestAccordianData.accordianTouched', []),
    // accordianCreateTouched: _.get(state, 'contentRequestData.contentRequestAccordianData.accordianCreateTouched', []),
    bulkImportCount: _.get(state, 'bulkImportCount.count', 0),
    checkAll: _.get(state, 'bulkImportCount.checkAll', []),
    selectAll: _.get(state, 'bulkImportCount.selectAll', {}),
    filteredQuestionArray: _.get(state, 'contentRequestData.contentRequestAccordianData.filteredQuestionArray', []),
    selectedQuestionsBySelectAll: _.get(state, 'bulkImportCount.selectedQuestionsBySelectAll', []),
    questionTabDetails: _.get(state, 'bulkImportCount.questionTabDetails', []),
    contentRequestItemsIdForFirstTime: _.get(state, 'contentRequestData.contentRequestAccordianData.contentRequestItemsIdForFirstTime', ''),
    isClickedOnImport: _.get(state, 'contentRequestData.contentRequestAccordianData.isClickedOnImport', false)
});

const mapDispatchToProps = (dispatch: any) => bindActionCreators({
    setContentRequestState: contentRequestStateAction.setContentRequestStates,
    setAccordianState: contentRequestAccordianActions.setAccordianState,
    setAccordingTouchIndex: contentRequestAccordianActions.setAccordingTouchIndex,
    setContentRequestItemsIdForFirstTime: contentRequestAccordianActions.setContentRequestItemsIdForFirstTime,
    setFilterQuestionArray: contentRequestAccordianActions.setFilterQuestionArray,
    setSelectedQuestionsBySelectAll,
    setQuestionTabDetails,
    showMsg: showMsg,
    setResetQuestionsBySelectAll,
    selectAllCheckbox: selectAllCheckbox,
    setSelectAll: setSelectAll,
    setIsClickedOnImport: contentRequestAccordianActions.setIsClickedOnImport
}, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
    // @ts-ignore
)(withStyles(styles)(SelectWithContent));